import { Typography } from '@mui/material'
import React from 'react'
import { fontSizes, fontWeights } from '../../../Common/Typography/TypographyStyles'

interface TaskTitleProps {
  value: string
}

const TaskTitle: React.FC<TaskTitleProps> = ({ value }) => {
  return (
    <Typography
      sx={{
        maxWidth: 200,
        whiteSpace: 'normal',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textAlign: 'left',
        display: 'block',
        margin: '0 auto',
        fontSize: fontSizes.size12,
        fontWeight: fontWeights[700],
      }}
    >
      {value}
    </Typography>
  )
}

export default TaskTitle
